// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAHae0N7OIykggTT6yaSQYISBKD4mQWZGQ",
  authDomain: "mnba-75a36.firebaseapp.com",
  projectId: "mnba-75a36",
  storageBucket: "mnba-75a36.appspot.com",
  messagingSenderId: "536416257352",
  appId: "1:536416257352:web:592a0bc8f582ad71455f7d",
  measurementId: "G-451N667KCZ"
};

// Initialize Firebase
const appFirebase = initializeApp(firebaseConfig);

export default appFirebase;
